


$(function(){
	var headerHeight = jQuery('header').outerHeight();

	$('a[href*="#"]').click(function () {
		var target = jQuery(this.hash === '' ? 'html' : this.hash);
		var position = target.offset().top - headerHeight;
		if (target.length) {
			jQuery('html, body').animate({scrollTop:position}, 500, 'swing');
			return false;
		}
	});

	var urlHash = location.hash;
	if(urlHash) {
		var target = jQuery(urlHash);
		var position = target.offset().top - headerHeight;
		$('body,html').stop().scrollTop(0);
		setTimeout(function(){
			$('body,html').stop().animate({scrollTop:position}, 1000, 'swing');
		}, 150);
	}
});


$(function(){
  $('.faq-defTtl').click(function(){
    $(this).next('.faq-defDesc').slideToggle();
    $(this).toggleClass("open");
  });
});


$(function () {
  let scrollY = 0;

  function lockBody() {
    scrollY = window.scrollY || window.pageYOffset;
    document.documentElement.classList.add('nav-open'); // ← これを判定に使う
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';
  }

  function unlockBody() {
    const y = -(parseInt(document.body.style.top || '0', 10));
    document.documentElement.classList.remove('nav-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, y);
  }

  $('#nav-toggle').on('click', function () {
    const willOpen = !$(this).hasClass('active');
    $(this).toggleClass('active');
    $('.gnavCont').fadeToggle(300);

    if (willOpen) {
      lockBody();
    } else {
      unlockBody();
    }
  });

  $('.gnavCont a').on('click', function () {
    $('#nav-toggle').removeClass('active');
    $('.gnavCont').fadeOut(300);
    unlockBody();
  });
});



jQuery(function($){
  $('.btn').hover(
    function(){
      $(this).addClass('hover');
    },
    function(){
      $(this).removeClass('hover');
    }
  );
});

$(function(){
 const header = document.querySelector('.header');
  let lastY = window.scrollY;
  let downAccum = 0, upAccum = 0;
  const THRESHOLD = 8;
  const REVEAL_TOP = 64;

  function onScroll(){
    // 🚫 メニュー展開中は処理しない
    if (document.documentElement.classList.contains('nav-open')) return;

    const y = Math.max(0, window.scrollY);
    const delta = y - lastY;

    if (delta > 0){
      downAccum += delta; upAccum = 0;
      if (y > REVEAL_TOP && downAccum > THRESHOLD){
        header.classList.add('is-hidden');
      }
    } else if (delta < 0){
      upAccum += -delta; downAccum = 0;
      if (upAccum > THRESHOLD){
        header.classList.remove('is-hidden');
      }
    }
    lastY = y;
  }

  window.addEventListener('scroll', onScroll, { passive: true });
});




$(function () {
	var mySwiper = new Swiper('.swiper', {
		autoplay: {
			delay: 3000, // ← 表示時間を少し長めに
			disableOnInteraction: false,
			waitForTransition: false,
		},
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		loop: true,
		speed: 3000, // ← フェード速度を1.5秒くらいに調整
		allowTouchMove: false,
	});
});

